import React, { memo, useCallback } from 'react';

import { constants, useAccountNumbersForm, useAccountNumbersState } from '@atlas/core';
import { Button, HeaderTitle, Label, Radio } from '@atlas/ui';

import AccountNumberFieldDropdown from './AccountNumberFieldDropdown';
import AccountNumberFieldNumeric from './AccountNumberFieldNumeric';
import BankNameCombobox from './BankNameCombobox';

const { ACCOUNT_NUMBERS_FIELDS } = constants;

const FIELD_TYPES = {
  BANK_NAME_COMBOBOX: 'BANK_NAME_COMBOBOX',
  NUMBER: 'NUMBER',
  SELECT: 'SELECT',
};

const fields = [
  {
    hint: 'account_numbers_bank_name_hint',
    name: ACCOUNT_NUMBERS_FIELDS.BANK_NAME,
    type: FIELD_TYPES.BANK_NAME_COMBOBOX,
  },
  { hidden: true, hint: '', name: ACCOUNT_NUMBERS_FIELDS.BANK_CODE, type: FIELD_TYPES.NUMBER },
  {
    hint: 'account_numbers_branch_number_hint',
    name: ACCOUNT_NUMBERS_FIELDS.BRANCH_CODE,
    type: FIELD_TYPES.NUMBER,
  },
  {
    hint: 'account_numbers_account_number_hint',
    name: ACCOUNT_NUMBERS_FIELDS.ACCOUNT_NUMBER,
    type: FIELD_TYPES.NUMBER,
  },
  {
    hint: 'account_numbers_account_type_hint',
    name: ACCOUNT_NUMBERS_FIELDS.ACCOUNT_TYPE,
    type: FIELD_TYPES.SELECT,
  },
];

const Field = {
  [FIELD_TYPES.BANK_NAME_COMBOBOX]: BankNameCombobox,
  [FIELD_TYPES.NUMBER]: AccountNumberFieldNumeric,
  [FIELD_TYPES.SELECT]: AccountNumberFieldDropdown,
};

const AccountNumberForm = ({ fieldIndex, useByDefault }) => {
  const { removeField, setDefault } = useAccountNumbersState();
  const { isDeleteButtonVisible } = useAccountNumbersForm();

  const onRemoveFieldHandler = useCallback(() => {
    removeField({ fieldIndex });
  }, [fieldIndex, removeField]);

  const onSetDefaultHandler = useCallback(() => {
    setDefault({ fieldIndex });
  }, [fieldIndex, setDefault]);

  return (
    <div className="account-number-form">
      <div className="account-number-form__name">
        <HeaderTitle title={`account_numbers_account_number_${fieldIndex + 1}`} />
        {isDeleteButtonVisible && (
          <Button
            className="btn delete-field-button"
            icon="close"
            onClick={onRemoveFieldHandler}
            size="small"
          >
            <Label message="account_numbers_delete_account" />
          </Button>
        )}
      </div>
      <div className="account-number-form__fields">
        {fields.map(field => {
          const FieldComponent = Field[field.type];

          if (field.hidden) {
            return null;
          }

          return (
            <FieldComponent
              fieldIndex={fieldIndex}
              hint={field.hint}
              key={field.name}
              name={field.name}
              readOnly={field.readOnly}
              type={field.type}
            />
          );
        })}
      </div>
      <Radio active={useByDefault} onClick={onSetDefaultHandler} text="default_account" />
    </div>
  );
};

export default memo(AccountNumberForm);
